export default "__VITE_ASSET__C_20nEUO__"